export enum AllowedSports {
  soccer = 'soccer',
  hockey = 'hockey',
}

export type NumOfTeams = number[]

export type CustomTitle = string[]

export interface SportTableInlineProps {
  kind: ['widget', 'sport', 'table-inline']
  currentSeasonId: string
  typeOfSport: AllowedSports
  numOfTeams: NumOfTeams
  customTitle: CustomTitle
}
